import styled from 'styled-components';
import Button from "../../components/Button/Button.component";
import {ImgWrap} from "../../components/SideBar/styles";

export const StyledImgWrap = styled(ImgWrap)`
  width:8rem;
  height:8rem;
`;

export const StyledWrap = styled.div`
  position:relative;
  width:100%;
  .k-dateinput{
    width:100%;
    + div{
      position:absolute;
      top:50%;
      transform:translateY(-50%);
      right:4.5rem;
    }
  }
  div + div{
      position:absolute;
      top:50%;
      transform:translateY(-50%);
      right: 1.5rem;
      height: 100%;
      display: flex;
      align-items: center;
    }
`;

export const SyledButton = styled(Button)`
  margin-right:1.5rem;
`;
